// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__Q0qYJ","content":"modal_content__a5O4F","body":"modal_body__bw4xS"};